<template>
	<GalleryComponent :pictureData="layoutData" :index="index" :pictureKey="pictureKey" isMultiblock="false" />
</template>

<script>

import GalleryComponent from "./GalleryComponent.vue";

export default {
	components: {
		GalleryComponent
	},
	props: {
		layoutData: {
			type: Object
		},
		index: {
			type: Number
		},
		pictureKey: {
			type: Number
		},
	}
};
</script>

<style lang="scss" scoped>
</style>